import type { RouteObject } from 'react-router-dom';

/**
 * Dashboard area. OWNED BY `m12-dashboards` (M12); see docs/BUILD-ORCHESTRATION.md.
 *
 * Add screens as children below. router.tsx already includes these routes, so a new
 * screen inside this area never needs a change outside this folder. Pages load lazily.
 */
export const dashboardRoutes: RouteObject[] = [
  { index: true, handle: { crumb: 'Home' }, lazy: async () => ({ Component: (await import('./DashboardPage')).DashboardPage }) },
];
